var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('script',{ref:"script",attrs:{"name":_vm.name,"type":"text/plain"}}),_vm._v(" "),_c('lb-upload',{attrs:{"type":"more","fileType":_vm.fileType,"visibles":_vm.showDialog,"isIframe":_vm.isIframe,"multilineType":"more"},on:{"update:visibles":function($event){_vm.showDialog=$event},"selectedFiles":_vm.getChoiceFiles}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b019ef46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basics/lbUeditor.vue
// module id = null
// module chunks = 